<mat-card>
  <mat-card-content>
    <app-search-bar
      [primaryButtonAction]="primaryButtonAction"
      [primaryButtonKey]="'parameters/external-authorizations/create'">
    </app-search-bar>
    <app-table [config]="config" [filters]="filters"></app-table>
  </mat-card-content>
</mat-card>
